export const getCookie = (name: string): string | null => {
  const cookies = document.cookie?.split('; ') || [];
  const cookie = cookies.find(row => row.startsWith(name + '='));
  return cookie?.split('=')[1] || null;
};
